export enum PublishTaskType {
  PUBLISH_TO_SENTIENCE = 'PublishToSentience',
  ONBOARDING_ANALYTICS_SETUP = 'OnBoardingAnalyticsSetup',
  ONBOARDING_IMPORT_HISTORY = 'OnBoardingImportHistory',
  ONBOARDING_IMPORT_MODEL = 'OnBoardingImportModel'
}
